import { render, staticRenderFns } from "./SharedItemNotification.vue?vue&type=template&id=bc533c30&"
import script from "./SharedItemNotification.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SharedItemNotification.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports